import { useDispatch, useSelector } from 'react-redux';
import { navigateTo } from '../../redux/Slice/navigationSlice';
import { Button, WorkInProgressSVG } from 'common-ui-components';
import { selectConfig } from '../../redux/selectors';
import { Controller, useForm } from 'react-hook-form';
import { DOCUMENT_TYPES_ARGENTINA } from '../../utils/constants';
import { NumericInput } from '../../components/NumericInput';
import { resetReferralState, setReferralIdu, setReferralPersonalData, validateReferral } from '../../redux/Slice/referralSlice';
import { useEffect } from 'react';
import Terms from '../../components/Terms';
import { useSearchParams } from 'react-router-dom';

const SelectDocumentTypeScreen = () => {
  const [searchParams] = useSearchParams();
  const idu = searchParams.get('idu') || '';
  const dispatch = useDispatch();
  const {
    language: { selectDocumentTypeScreen: text, terms: termsText },
  } = useSelector(selectConfig);
  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    watch
  } = useForm({ mode: 'onChange', shouldFocusError: false, defaultValues: { documentType: 'DNI', documentNumber: '', terms: false } });

  const selectedDocumentType = watch('documentType');

  useEffect(() => {
    dispatch(resetReferralState());
    dispatch(setReferralIdu(idu));
  }, []);

  const getValidationRules = () => {
    const selectedDoc = DOCUMENT_TYPES_ARGENTINA.find((doc) => doc.id === selectedDocumentType);

    const rules = {
      required: { value: true, message: 'Obligatorio' },
    };

    if (selectedDoc) {
      rules.minLength = {
        value: selectedDoc.minLength,
        message: `Mínimo ${selectedDoc.minLength} caracteres`,
      };
      rules.maxLength = {
        value: selectedDoc.maxLength,
        message: `Máximo ${selectedDoc.maxLength} caracteres`,
      };
    }

    return rules;
  };

  const getMaxLength = () => {
    const selectedDoc = DOCUMENT_TYPES_ARGENTINA.find((doc) => doc.id === selectedDocumentType);
    return selectedDoc ? selectedDoc.maxLength : undefined;
  };

  const onSubmit = async (data) => {
    try {
      const response = await dispatch(validateReferral({
        identificationType: data.documentType,
        identificationNumber: data.documentNumber,
      })).unwrap();
      if (!response) {
        throw new Error('Validación de referral fallida');
      }
      dispatch(setReferralPersonalData(data));
      dispatch(navigateTo('ValidateCoverage'));
    } catch (error) {
      switch (error?.errorCode) {
        case '100006':
          dispatch(navigateTo('CantParticipateError'));
          break;
        case '100002':
          dispatch(navigateTo('NotMeetingRequirementsErrorRef'));
          break;
        case '100018':
          dispatch(navigateTo('AlreadyProcessingReferralErrorRef'));
          break;
        default:
          dispatch(navigateTo('NotMeetingRequirementsErrorRef'));
      }
    }
  };

  return (
    <section className='section selectDocumentTypeScreen'>
      <div className='selectDocumentTypeScreen-background'></div>
      <div className='selectDocumentTypeScreen-top'>
        <WorkInProgressSVG transparent style={{ width: '200px', scale: '.8' }} />
      </div>
      <div className='selectDocumentTypeScreen-content'>
        <p className='selectDocumentTypeScreen-subtitle' dangerouslySetInnerHTML={{ __html: text.subtitle }} />
        <form className='selectDocumentTypeScreen-form' onSubmit={handleSubmit(onSubmit)}>
          <div className='welcomeForm-inputWrapper'>
            <Controller
              name='documentNumber'
              defaultValue=''
              control={control}
              rules={getValidationRules()}
              render={({ field: { name, onChange, ref, value, disabled } }) => (
                <NumericInput
                  id='documentNumber'
                  data-testid='documentNumber'
                  name={name}
                  onChange={onChange}
                  ref={ref}
                  value={value}
                  disabled={disabled}
                  status={errors.documentNumber ? 'error' : 'default'}
                  label='Número de documento'
                  labelText='Número de documento'
                  helpText={errors.documentNumber ? errors.documentNumber.message : ''}
                  typeInput='number'
                  maxLength={getMaxLength()}
                />
              )}
            />
          </div>
          <Controller
            name='terms'
            defaultValue={false}
            control={control}
            rules={{
              required: true,
            }}
            render={({ field: { name, onChange, value } }) => (
              <Terms onChange={onChange} value={value} name={name} text={termsText} />
            )}
          />

          <Button
            className='submit-button-error'
            type='submit'
            disabled={!isValid}
            data-testid='selectDocumentTypeScreen-continue-button'
          >
            Continuar
          </Button>
        </form>
      </div>
    </section>
  );
};

export default SelectDocumentTypeScreen;
